module.exports = __webpack_public_path__ + "img/banner-back-main.192d56c4.png";